import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import suitcss from '../../../helpers/suitcss';
import TextCopy from '../text/TextCopy';

const componentName = 'Accordion';

const Accordion = ({
  title,
  hash,
  locationHash,
  elementName,
  children,
  trackingFunction,
  titleRaw = false,
  highlighted = false,
  forceOpen = false,
  open = false,
  showTitle = true,
  primaryArrow = false,
  thickArrow = false,
  fullWidth = true,
  centered = false,
  titleElement,
}) => {
  const focusRef = useRef();

  useEffect(() => {
    if (trackingFunction && locationHash && hash && locationHash === hash) {
      trackingFunction(hash);
    }
    if (focusRef.current && locationHash && hash && locationHash === hash) {
      focusRef.current.focus();
    }
  }, [locationHash, hash]);

  const ElementDetails = (forceOpen || title === null) ? 'div' : 'details';
  const ElementTitle = forceOpen ? 'div' : 'summary';

  const wrapperClassNames = suitcss({
    componentName,
    descendantName: elementName ? '' : 'wrapper',
    modifiers: [
      elementName,
      forceOpen && 'forceOpen',
      highlighted && 'highlighted',
      fullWidth && 'fullWidth',
      centered && 'centered',
    ],
  });
  const itemProps = (forceOpen || title === null) ? {} : {
    open: open || (locationHash && locationHash.startsWith(hash)),
  };

  return (
    <ElementDetails className={wrapperClassNames} {...itemProps}>
      {(title !== null) && (
        <ElementTitle
          className={suitcss({
            componentName,
            descendantName: 'title',
            modifiers: [
              primaryArrow && 'primaryArrow',
              thickArrow && 'thickArrow',
            ],
          })}
        >
          {showTitle && (
            <TextCopy
              embedded
              raw={titleRaw}
              element={titleElement}
            >
              {title}
            </TextCopy>
          )}
        </ElementTitle>
      )}
      <div
        className={suitcss({
          componentName,
          descendantName: 'body',
        })}
        id={hash}
        ref={focusRef}
        tabIndex={-1}
      >
        {children}
      </div>
    </ElementDetails>
  );
};

Accordion.propTypes = {
  title: PropTypes.string,
  hash: PropTypes.string,
  titleRaw: PropTypes.bool,
  highlighted: PropTypes.bool,
  forceOpen: PropTypes.bool,
  open: PropTypes.bool,
  showTitle: PropTypes.bool,
  primaryArrow: PropTypes.bool,
  thickArrow: PropTypes.bool,
  fullWidth: PropTypes.bool,
  centered: PropTypes.bool,
  locationHash: PropTypes.string,
  elementName: PropTypes.string,
  trackingFunction: PropTypes.func,
  children: PropTypes.node,
  titleElement: PropTypes.string,
};

export default Accordion;
